// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__XCQbw","right":"styles_right__1a39D"};